import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

export interface PartCodeRecommendation {
    partCodeRecommended: boolean;
    partCodeValue: string;
}

@Injectable({
    providedIn: 'root'
})
export class PartCodeRecommendationService {
    
    private readonly API_PART_CODE_RECOMMENDATION_URL = `${environment.ipserver}o2c-backend/private/customerStatement/getPartCodeRecommendation`;

    constructor(private httpClient: HttpClient) { }

    /**
     * Get part code recommendations based on customer and delivery address
     * @param customer Customer number
     * @param deliveryAddress Delivery address
     * @param customerCode Customer code to analyze
     * @returns Observable<PartCodeRecommendation>
     * @author Castor Transformación Digital - AI Assistant
     * @since 2025-01-22
     */
    getPartCodeRecommendation(customer: string, deliveryAddress: string, customerCode: string): Observable<PartCodeRecommendation> {
        const params = new HttpParams()
            .set('customer', customer)
            .set('deliveryAddress', deliveryAddress)
            .set('customerCode', customerCode);

        return this.httpClient.get<PartCodeRecommendation>(this.API_PART_CODE_RECOMMENDATION_URL, { params });
    }
}
